<template>
	<v-layout row wrap justify-center align-center>
        <v-flex lg12 justify-center align-center>
            <v-toolbar-title>
                {{titulo}}
            </v-toolbar-title>
        </v-flex>
        <v-flex md12 lg11 xs12 sm11>
            <apexchart type=line height=400 :options="chartOptions" :series="series"></apexchart>
        </v-flex>
	</v-layout>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
    components: {
        apexchart
	},
	props: {
		values: Array,
		weekly: {
			type: Boolean,
			default: false
        },
        eixoYText: {
            type: String,
            default: 'Consumo (kg)'
        },
        titulo: {
            type: String,
            default: ''
        }
    },
    methods: {

    },
    data: function() {
        return {
			series: [
                {
                    name: this.weekly ? 'Esperado' : 'Esperado',
                    type: 'line',
                    data: this.values.esperado != undefined ? this.values.esperado : [0]
                },
                {
                    name: 'Realizado',
                    type: 'area',
                    data: this.values.real != undefined ? this.values.real : [0]
                }
			],
			chartOptions: {
                colors: ['#10303D', 'rgba(255,84,41,.7)'],
                dataLabels: {
                    enabled: false,
                },
                labels: this.values.nrDias,
                stroke: {
                    curve: 'straight',
                    dashArray: [5, 0],
                    width: [4, 4],
                },
				xaxis: {
                    title: {
                        text: 'Dias alojados',
                    },
                    labels: {
                        formatter: function (val) {
                            return val
                        },
                    },
                    tooltip: {
                        enabled: false
                    }
                },
				yaxis: {
                    title: {
                        text: this.eixoYText,
                    },
                    labels: {
                        formatter: function (val) {
                            return val.toFixed(3)
                        }
                    }
                },
                tooltip: {
                    style: {
                        fontSize: '14px',
                        fontFamily: undefined
                    },
                    y: {
                        formatter: function (val) {
                            return val + ' kg'
                        }
                    },
                },
				legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    fontSize: '14px',
                    labels: {
                        useSeriesColors: false
                    },
                },
			}
		}
    },
}

</script>

<style>
    .apexcharts-menu.open {
        color: black;
    }
    .apexcharts-tooltip {
        background: #f3f3f3;
        color: black;
    }
</style>
